import { Button, Col, Container, Form, Row, Spinner } from "react-bootstrap";
import MediaQueryTool from "../../utils/MediaQueryTool";
import FormTextField from "../../utils/FormTextField";
import FormTextArea from "../../utils/FormTextArea";
import FormFileUpload from "../../utils/FormFileUpload";
import { useEffect, useState } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ContactUs = () => {
  const mediaQueryTool = MediaQueryTool();
  const [showInquired, setShowInquired] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [inquiryList] = useState(
    JSON.parse(localStorage.getItem("inquiryList")) || []
  );

  const showToast = (e) => {
    toast.success(e, {
      position: "top-center",
      autoClose: 3000,
    });
  };

  const schema = yup.object().shape({
    firstName: yup.string().required("First Name is required"),
    lastName: yup.string().required("Last Name is required"),
    email: yup.string().email("Invalid email").required("Email is required"),
    description: yup.string(),
    charAmount: yup
      .number()
      .transform((value, originalValue) =>
        originalValue.trim() === "" ? undefined : value
      )
      .required("Character Amount is required")
      .typeError("Must be number")
      .min(1, "Must be at least 1"),
    details: yup.string(),
    commercial: yup.string().required("Please select an option"),
    artStyle: yup.string().required("Please select an art style"),
    file: yup
      .mixed()
      .test(
        "file",
        "You need to provide a file",
        (value) => value && value.length > 0
      )
      .test("fileType", "Unsupported file format", (value) => {
        return Array.from(value).every((file) =>
          ["image/jpeg", "image/png"].includes(file.type)
        );
      }),
  });

  const {
    register,
    setValue,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  useEffect(() => {
    if (localStorage.getItem("inquiryList")) {
      setShowInquired(true);
    } else {
      setShowInquired(false);
    }
  }, [inquiryList]);

  const handleFormSubmit = async (data) => {
    const formData = new FormData();

    formData.append("firstName", data.firstName);
    formData.append("lastName", data.lastName);
    formData.append("email", data.email);
    formData.append("description", data.description);
    formData.append("charAmount", data.charAmount);
    formData.append("artStyle", data.artStyle);
    formData.append("details", data.details);
    formData.append("commercial", data.commercial);
    formData.append(
      "inquiryList",
      inquiryList.length > 0 ? inquiryList.join(",") : null
    );

    Array.from(data.file).forEach((file, index) => {
      formData.append("file", file);
    });

    setIsLoading(true);

    axios
      .post(
        "https://sugarno_backend.sugarnoproject.workers.dev/sendEmail",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      )
      .then((response) => {
        localStorage.removeItem("inquiryList");
        window.location.reload();
        showToast(response.data.message);
      })
      .catch((error) => {
        showToast(error);

        console.error(error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <Container
      style={{
        marginTop: mediaQueryTool.isXS ? 55 : 90,
        marginBottom: mediaQueryTool.isXS ? 55 : undefined,
        paddingBottom: 90,
        color: "white",
      }}
    >
      {isLoading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.5)", // Optional overlay
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <Spinner animation="border" variant="primary" />
        </div>
      )}

      <ToastContainer />

      <Container
        className="d-flex flex-column align-items-center"
        style={{
          paddingLeft: mediaQueryTool.isXL ? 200 : undefined,
          paddingRight: mediaQueryTool.isXL ? 200 : undefined,
        }}
      >
        <h1
          className="neon-text2"
          style={{
            fontFamily: "CyberpunkFont",
          }}
        >
          Contact Us
        </h1>
      </Container>

      <Row className="mt-4">
        <Col
          xs={{ order: 2 }}
          sm={{ order: 2 }}
          md={{ order: 1 }}
          lg={8}
          style={{
            marginTop: mediaQueryTool.isXS
              ? 30
              : mediaQueryTool.isSM
              ? 30
              : undefined,
          }}
        >
          <Container
            className="contactContainer px-md-5"
            style={{
              paddingBottom: "50px",
              padding: "20px",
            }}
          >
            <h1
              className="neon-text"
              style={{
                fontFamily: "CyberpunkFont",
                textAlign: "center",
              }}
            >
              Commission Form
            </h1>
            <Form
              className="mt-5"
              style={{
                display: "flex",
                flexDirection: "column",
              }}
              onSubmit={handleSubmit(handleFormSubmit)}
            >
              <Row>
                <Col xs={12} sm={6}>
                  <FormTextField
                    id="firstName"
                    type="text"
                    name="firstName"
                    label="First Name"
                    placeholder="First Name"
                    control={register("firstName")}
                    error={errors.firstName}
                  />
                </Col>
                <Col xs={12} sm={6}>
                  <FormTextField
                    id="lastName"
                    className={`${mediaQueryTool.isXS ? "mt-2" : undefined}`}
                    type="text"
                    name="lastName"
                    label="Last Name"
                    placeholder="Last Name"
                    control={register("lastName")}
                    error={errors.lastName}
                  />
                </Col>
              </Row>
              <FormTextField
                id="email"
                className="mt-2"
                type="email"
                label="Email"
                name="email"
                placeholder="Email"
                control={register("email")}
                error={errors.email}
              />
              <FormTextArea
                id="description"
                className="mt-2"
                name="description"
                label="Description"
                control={register("description")}
                placeholder="Description"
              />
              <FormTextField
                id="charAmount"
                className="mt-2"
                name="charAmount"
                label="Character Amount"
                placeholder="Character Amount"
                control={register("charAmount")}
                error={errors.charAmount}
              />

              <FormTextArea
                id="details"
                className="mt-2"
                name="details"
                control={register("details")}
                label="In-depth Details"
                placeholder="In-depth Details"
              />

              <Form.Group className="mt-2">
                <Form.Label>Commercial Use?</Form.Label>
                <div style={{ display: "flex" }}>
                  <Form.Check
                    className={errors.commercial ? "error-radio" : ""}
                    type="radio"
                    label="Yes"
                    value={"Yes"}
                    id={`commercial-yes`}
                    name="commercial"
                    {...register("commercial", {
                      required: "Please select an option",
                    })}
                    style={{ marginRight: "30px" }}
                  />
                  <Form.Check
                    className={errors.commercial ? "error-radio" : ""}
                    type="radio"
                    label="No"
                    value={"No"}
                    id={`commercial-no`}
                    name="commercial"
                    {...register("commercial", {
                      required: "Please select an option",
                    })}
                  />
                </div>
                {errors.commercial && (
                  <p className="text-danger">{errors.commercial.message}</p>
                )}
              </Form.Group>

              <Form.Group className="mt-2">
                <Form.Label>2D or Semi Realism</Form.Label>
                <div style={{ display: "flex" }}>
                  <Form.Check
                    className={errors.artStyle ? "error-radio" : ""}
                    type="radio"
                    label="2D Art"
                    value={"2d Art"}
                    id={`2dArt`}
                    name="artStyle"
                    {...register("artStyle", {
                      required: "Please select an art style",
                    })}
                    style={{ marginRight: "30px" }}
                  />
                  <Form.Check
                    type="radio"
                    className={errors.artStyle ? "error-radio" : ""}
                    label="Semi Realism"
                    value={"Semi Realism"}
                    id={`semiRealism`}
                    name="artStyle"
                    {...register("artStyle", {
                      required: "Please select an art style",
                    })}
                  />
                </div>
                {errors.artStyle && (
                  <p className="text-danger">{errors.artStyle.message}</p>
                )}
              </Form.Group>

              <FormFileUpload
                id="file"
                className="mt-2"
                multiple
                label="References Upload"
                control={register("file")}
                setValue={setValue}
                error={errors.file}
              />

              <p
                style={{
                  fontWeight: "bold",
                  marginTop: 30,
                  padding: "15px",
                  border: "2px solid white",
                  borderRadius: "8px",
                  color: "red",
                  backgroundColor: "#ffe6e6",
                }}
              >
                🚨 Sugarno accepts bank transfers (Maybank, Public Bank, CIMB
                Bank, RHB Bank, AmBank, OCBC Bank) and PayPal.
              </p>

              <Button className="mt-4" variant="primary" type="submit">
                Submit
              </Button>
            </Form>
          </Container>
        </Col>

        <Col
          className="px-4"
          xs={{ order: 1 }}
          sm={{ order: 1 }}
          md={{ order: 2 }}
          lg
        >
          <Row>
            <Container
              className="dangerContactContainer"
              style={{
                paddingTop: "20px",
                paddingBottom: "10px",
                paddingLeft: "30px",
                paddingRight: "30px",
              }}
            >
              <p>Sugarno does not accept these requests:</p>
              <ul>
                <li>Furry</li>
                <li>NSFW</li>
                <li>Gore</li>
                <li>Mecha</li>
              </ul>
              <p>
                Sugarno also reserves the right to refuse requests not listed
                here.
              </p>
            </Container>
          </Row>
          {showInquired && (
            <Row>
              <Container
                className="contactContainer"
                style={{
                  paddingTop: "20px",
                  paddingBottom: "10px",
                  paddingLeft: "30px",
                  paddingRight: "30px",
                  marginTop: "30px",
                }}
              >
                <h1
                  className="neon-text"
                  style={{
                    fontFamily: "CyberpunkFont",
                    textAlign: "center",
                  }}
                >
                  Inquired List
                </h1>
                <ul className="mt-4">
                  {inquiryList.map((item, index) => {
                    return <li key={index}>{item}</li>;
                  })}
                </ul>
              </Container>
            </Row>
          )}
        </Col>
      </Row>
    </Container>
  );
};

export default ContactUs;
